import React from 'react';
import * as PropTypes from 'prop-types';
import { Sidebar } from './Sidebar';
import Banner from './Banner';
import pages from '../../../pages';
import styles from './Layout.module.scss';

const Layout = props => {
    const { children } = props;
    return (
        <div className={styles.container}>
            <Banner type="info" />
            <div className={styles.columnContainer}>
                <div className={styles.sidebar}>
                    <Sidebar items={pages} />
                </div>
                <div className={styles.mainContent}>{children}</div>
            </div>
        </div>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;
